import { TableBody, TableCell, TableRow } from '@/components/ui';
import { Skeleton } from '@/components/custom';

interface TProps {
    rows?: number;
}

const DataTableBodySkeleton = ({ rows = 5 }: TProps) => {
    return (
        <TableBody>
            {Array.from({ length: rows }).map((_, index) => (
                <TableRow key={index} className="h-10">
                    {/* Row # */}
                    <TableCell className="w-8 py-1">
                        <Skeleton className="h-4 w-6" />
                    </TableCell>
                    {/* Name */}
                    <TableCell className="py-1">
                        <Skeleton className="h-4 w-32" />
                    </TableCell>
                    {/* Role */}
                    <TableCell className="py-1">
                        <Skeleton className="h-4 w-24" />
                    </TableCell>
                    {/* Amount */}
                    <TableCell className="py-1">
                        <Skeleton className="h-4 w-20" />
                    </TableCell>
                    {/* Type */}
                    <TableCell className="py-1">
                        <div className="flex items-center gap-2">
                            <Skeleton className="h-4 w-4 rounded" />
                            <Skeleton className="h-4 w-16" />
                        </div>
                    </TableCell>
                    {/* Date */}
                    <TableCell className="py-1">
                        <Skeleton className="h-4 w-20" />
                    </TableCell>
                    {/* Options */}
                    <TableCell className="text-right py-1">
                        <Skeleton className="h-6 w-6 rounded ml-auto" />
                    </TableCell>
                </TableRow>
            ))}
        </TableBody>
    );
};

export default DataTableBodySkeleton;
